module.exports = __webpack_public_path__ + "static/reduction-848a31b55c4ddffc3f068456bddc1b3a.png";